// extracted by mini-css-extract-plugin
module.exports = {"content":"Reassign_content__3XNCr"};